<template>
  <div class="information-page">
    <!-- 顶部导航栏 -->
    <header class="information-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <div class="nav-back-wrapper">
          <button class="nav-back-btn" @click="goBack">
            <i class="el-icon-arrow-left"></i>
          </button>
        </div>
        <div class="nav-title">个人信息</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="content-wrapper">
      <!-- 基础信息 -->
      <div class="info-section">
        <div class="section-title">基础信息</div>
        <div class="info-list">
          <div class="li" @click="userShow()">
      <div class="name"><span class="required">*</span>用户名</div>
      <div class="value" v-if="uesr">
        {{ uesr }} <i class="el-icon-arrow-right"></i>
      </div>
      <div class="value" v-else>
        请输入用户名 <i class="el-icon-arrow-right"></i>
      </div>
    </div>
          <div class="li" @click="genderShow()">
            <div class="name"><span class="required">*</span>性别</div>
            <div class="value">{{ gender }} <i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="timeClick()">
            <div class="name"><span class="required">*</span>出生日期</div>
            <div v-if="birthday == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ birthday }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="ethnicityClick()">
            <div class="name"><span class="required">*</span>民族</div>
            <div v-if="ethnicity == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ ethnicity }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="residenceClick()">
            <div class="name"><span class="required">*</span>常住地址</div>
            <div v-if="residence == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value"><span>{{ getResidenceDisplayText() }}</span><i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="IDNumberShow()">
            <div class="name"><span class="required">*</span>证件号</div>
            <div class="value" v-if="IDNumber">
              {{ maskIdCard(IDNumber) }} <i class="el-icon-arrow-right"></i>
            </div>
            <div class="value" v-else>
              请输入证件号 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 健康信息 -->
      <div class="info-section">
        <div class="section-title">健康信息</div>
        <div class="info-list">
          <div class="li" @click="showPicker = true">
            <div class="name"><span class="required">*</span>身高</div>
            <div v-if="height == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div class="value" v-else>{{ height }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="showPicker1 = true">
            <div class="name"><span class="required">*</span>体重</div>
            <div v-if="weight == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div class="value" v-else>{{ weight }} <i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="waistlineShow()">
            <div class="name"><span class="required">*</span>腰围</div>
            <div v-if="waistline == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ waistline }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="smokingStatusClick()">
            <div class="name"><span class="required">*</span>是否吸烟</div>
            <div v-if="smokingStatus == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ smokingStatus }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li industry-item" @click="industryClick()">
            <div class="name"><span class="required">*</span>所在行业</div>
            <div v-if="industry == ''" class="value" style="color:#C0C0C0"><span>请选择</span><i class="el-icon-arrow-right"></i></div>
            <div v-else class="value"><span>{{ industry }}</span><i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="sleepQualityClick()" v-if="true">
            <div class="name"><span class="required">*</span>睡眠质量</div>
            <div v-if="sleepQuality == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ sleepQuality }}<i class="el-icon-arrow-right"></i></div>
          </div>
        </div>
      </div>

      <!-- 其他信息 -->
      <div class="info-section">
        <div class="section-title">其他信息</div>
        <div class="info-list">
          <div class="li" @click="dietaryHabitsClick()">
            <div class="name"><span class="required">*</span>日常饮食习惯</div>
            <div v-if="dietaryHabits == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ dietaryHabits }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="dietPreferenceClick()">
            <div class="name"><span class="required">*</span>日常饮食偏好</div>
            <div v-if="dietPreference == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ dietPreference }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="drinkingStatusClick()">
            <div class="name"><span class="required">*</span>饮酒状态</div>
            <div v-if="drinkingStatus == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ drinkingStatus }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li exercise-item" @click="exerciseFreqClick()">
            <div class="name"><span class="required">*</span>每周运动时长</div>
            <div v-if="exerciseFreq == ''" class="value" style="color:#C0C0C0"><span>请选择</span><i class="el-icon-arrow-right"></i></div>
            <div v-else class="value"><span>{{ exerciseFreq }}</span><i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="homeAddressShow()">
            <div class="name">家庭地址</div>
            <div class="value" v-if="userDetailAddress">
              {{ userDetailAddress }} <i class="el-icon-arrow-right"></i>
            </div>
            <div class="value" v-else style="color:#C0C0C0">
              请选择 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="li" @click="communityPhoneShow()">
            <div class="name">社区电话</div>
            <div class="value" v-if="communityPhone">
              {{ communityPhone }} <i class="el-icon-arrow-right"></i>
            </div>
            <div class="value" v-else style="color:#C0C0C0">
              请选择 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-button-container">
        <div class="save-button" @click="edit()">
          <img src="@/assets/personalInformation/SaveBackground.png" alt="保存背景" class="save-bg-img" />
          <span class="save-text">保存个人信息</span>
        </div>
      </div>
    </div>

    <van-dialog v-model="cover" :title="getDialogTitle()" show-cancel-button @confirm="qdClikc" :lazy-render="false">
      <div style="padding: 0px 20px 20px 20px; width: 100%; margin: 0 auto">
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 1"
          >
            <el-input v-model="userInput"  @focus="focusEvent($event)" placeholder="请输入用户名"></el-input>
          </div>
          <div
            class="gender"
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              text-align: justify;
              font-style: normal;
            "
            v-if="type == 2"
          >
            <div @click="Sexselection(1)">
              男
              <i class="el-icon-success" v-if="genderInput == '男'"></i>
              <div class="round" v-else></div>
            </div>
          </div>
          <div
            class="gender"
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              text-align: justify;
              font-style: normal;
            "
            v-if="type == 2"
          >
            <div @click="Sexselection(2)">
              女
              <i class="el-icon-success" v-if="genderInput == '女'"></i>
              <div class="round" v-else></div>
            </div>
          </div>
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 3"
          >
            <el-input
              v-model="IDNumberInput"
              @focus="focusEvent($event)"
              placeholder="请输入证件号"
            ></el-input>
            <div class="ts" v-if="ts">请输入正确的身份证号码！</div>
            <div ></div>
          </div>
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 4"
          >
            <div style="color: #666; font-size: 14px; margin-bottom: 10px; text-align: center;">
              请添加详细地址，便于我们提供精准服务
            </div>
            <el-input
              v-model="homeAddressInput"
              @focus="focusEvent($event)"
              placeholder="请输入详细地址"
            ></el-input>
          </div>
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 5"
          >
            <div style="color: #666; font-size: 14px; margin-bottom: 10px; text-align: center;">
              请添加社区电话，这样如果一键救援暂时联系不上您，我们也能通过社区电话联系到您~
            </div>
            <el-input
              v-model="communityPhoneInput"
              @focus="focusEvent($event)"
              placeholder="请输入社区电话"
            ></el-input>
          </div>
        </div>
      </van-dialog>
    <!-- <div v-show="cover" class="Popupclass" id="btm-keyboard-div">
      <div class="close" >
        <div style="padding: 3vw; text-align: left">
        </div>
        <div style="margin-bottom: 25px">
          <div
            style="
              font-size: 17px;
              text-align: center;
              color: #000000;
              font-weight: 500;
            "
          >
            <div class="qx" @click="cover = false">取消</div>
            <span v-if="type == 1">修改用户名</span>
            <span v-else-if="type == 3">修改证件号</span>
            <span v-else-if="type == 2">修改性别</span>
            <div class="qd" @click="qdClikc()">确定</div>
          </div>
        </div>
        <div style="padding: 0px 20px; width: 100%; margin: 0 auto">
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 1"
          >
            <el-input v-model="userInput"  @focus="focusEvent($event)" placeholder="请输入用户名"></el-input>
          </div>
          <div
            class="gender"
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              text-align: justify;
              font-style: normal;
            "
            v-if="type == 2"
          >
            <div @click="Sexselection(1)">
              男
              <i class="el-icon-success" v-if="genderInput == '男'"></i>
              <div class="round" v-else></div>
            </div>
          </div>
          <div
            class="gender"
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              text-align: justify;
              font-style: normal;
            "
            v-if="type == 2"
          >
            <div @click="Sexselection(2)">
              女
              <i class="el-icon-success" v-if="genderInput == '女'"></i>
              <div class="round" v-else></div>
            </div>
          </div>
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 3"
          >
            <el-input
              v-model="IDNumberInput"
              @focus="focusEvent($event)"
              placeholder="请输入证件号"
            ></el-input>
            <div class="ts" v-if="ts">请输入正确的身份证号码！</div>
            <div ></div>
          </div>
        </div>
      </div>
    </div> -->
    <div id="cover" v-if="cover"></div>
    <picke
      @child-method="parentMethod"
      @child-show="childShow"
      :value="value"
      :birthday="birthday"
    ></picke>
    <div>
      <van-popup v-model:show="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="idTypecolumn"
          @confirm="onConfirm"
          @cancel="cancel"
        />
      </van-popup>
      <van-popup v-model:show="showPicker1" round position="bottom">
        <van-picker
          show-toolbar
          :columns="idTypecolumn1"
          @confirm="onConfirm1"
          @cancel="cancel1"
        />
      </van-popup>
    </div>
      <van-popup v-model:show="sleepQualityPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="sleepQualityColumns"
          @confirm="sleepQualityonConfirm"
          @cancel="sleepQualitycancel"
        />
      </van-popup>
      <van-popup v-model:show="waistlinePicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="waistlineColumns"
          @confirm="waistlineonConfirm"
          @cancel="waistlinecancel"
        />
      </van-popup>
      <van-popup v-model:show="smokingStatusPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="smokingStatusColumns"
          @confirm="smokingStatusonConfirm"
          @cancel="smokingStatuscancel"
        />
      </van-popup>
      <van-popup v-model:show="ethnicityPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="ethnicityColumns"
          @confirm="ethnicityonConfirm"
          @cancel="ethnicitycancel"
        />
      </van-popup>
      <van-popup v-model:show="residencePicker" round position="bottom">
        <van-cascader
          :model-value="residenceCascaderValue"
          title="选择常住地"
          :options="residenceColumns"
          @close="residencecancel"
          @finish="residenceonConfirm"
          @update:model-value="residenceCascaderValue = $event"
        />
      </van-popup>
      <van-popup v-model:show="industryPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="industryColumns"
          @confirm="industryonConfirm"
          @cancel="industrycancel"
        />
      </van-popup>
      <van-popup v-model:show="dietaryHabitsPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="dietaryHabitsColumns"
          @confirm="dietaryHabitsonConfirm"
          @cancel="dietaryHabitscancel"
        />
      </van-popup>
      <van-popup v-model:show="dietPreferencePicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="dietPreferenceColumns"
          @confirm="dietPreferenceonConfirm"
          @cancel="dietPreferencecancel"
        />
      </van-popup>
      <van-popup v-model:show="drinkingStatusPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="drinkingStatusColumns"
          @confirm="drinkingStatusonConfirm"
          @cancel="drinkingStatuscancel"
        />
      </van-popup>
      <van-popup v-model:show="exerciseFreqPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="exerciseFreqColumns"
          @confirm="exerciseFreqonConfirm"
          @cancel="exerciseFreqcancel"
        />
      </van-popup>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import { health, uphealthinfo2 } from "@/api/activity";
import { evaluateDiseaseMedicationStatus } from '@/utils/healthReportProfileCheck';
export default {
  data() {
    return {
      smokingStatusId:'',
      industryId:'',
      dietPreferenceId:'',
      exerciseFreqId:'',
      sleepQualityId:'',
      dietaryHabitsId:'',
      drinkingStatusId:'',
      list:[],
      sleepQualityPicker:false,
      sleepQuality:'',
      ts: false,
      IDNumber: "",
      userDetailAddress: "",
      communityPhone: "",
      genderInput: "男",
      userInput: "",
      IDNumberInput: "",
      homeAddressInput: "",
      communityPhoneInput: "",
      uesr: "",
      gender: "男",
      birthday: "",
      height: "",
      weight: "",
      waistline: "",
      smokingStatus: "",
      ethnicity: "",
      residence: "",
      residenceCascaderValue: [],
      industry: "",
      dietaryHabits: "",
      dietPreference: "",
      drinkingStatus: "",
      exerciseFreq: "",
      cover: false,
      type: 1,
      value: false,
      waistlinePicker: false,
      smokingStatusPicker: false,
      ethnicityPicker: false,
      residencePicker: false,
      industryPicker: false,
      dietaryHabitsPicker: false,
      dietPreferencePicker: false,
      drinkingStatusPicker: false,
      exerciseFreqPicker: false,
      idTypecolumn: [
        { text: "150厘米", keyId: "150" },
        { text: "151厘米", keyId: "151" },
        { text: "152厘米", keyId: "152" },
        { text: "153厘米", keyId: "153" },
        { text: "154厘米", keyId: "154" },
        { text: "155厘米", keyId: "155" },
        { text: "156厘米", keyId: "156" },
        { text: "157厘米", keyId: "157" },
        { text: "158厘米", keyId: "158" },
        { text: "159厘米", keyId: "159" },
        { text: "160厘米", keyId: "160" },
        { text: "161厘米", keyId: "161" },
        { text: "162厘米", keyId: "162" },
        { text: "163厘米", keyId: "163" },
        { text: "164厘米", keyId: "164" },
        { text: "165厘米", keyId: "165" },
        { text: "166厘米", keyId: "166" },
        { text: "167厘米", keyId: "167" },
        { text: "168厘米", keyId: "168" },
        { text: "169厘米", keyId: "169" },
        { text: "170厘米", keyId: "170" },
        { text: "171厘米", keyId: "171" },
        { text: "172厘米", keyId: "172" },
        { text: "173厘米", keyId: "173" },
        { text: "174厘米", keyId: "174" },
        { text: "175厘米", keyId: "175" },
        { text: "176厘米", keyId: "176" },
        { text: "177厘米", keyId: "177" },
        { text: "178厘米", keyId: "178" },
        { text: "179厘米", keyId: "179" },
        { text: "180厘米", keyId: "180" },
        { text: "181厘米", keyId: "181" },
        { text: "182厘米", keyId: "182" },
        { text: "183厘米", keyId: "183" },
        { text: "184厘米", keyId: "184" },
        { text: "185厘米", keyId: "185" },
        { text: "186厘米", keyId: "186" },
        { text: "187厘米", keyId: "187" },
        { text: "188厘米", keyId: "188" },
        { text: "189厘米", keyId: "189" },
        { text: "190厘米", keyId: "190" },
        { text: "191厘米", keyId: "191" },
        { text: "192厘米", keyId: "192" },
        { text: "193厘米", keyId: "193" },
        { text: "194厘米", keyId: "194" },
        { text: "195厘米", keyId: "195" },
        { text: "196厘米", keyId: "196" },
        { text: "197厘米", keyId: "197" },
        { text: "198厘米", keyId: "198" },
        { text: "199厘米", keyId: "199" },
        { text: "200厘米", keyId: "200" },
      ],
      showPicker: false,
      idTypecolumn1: [
        { text: "30公斤", keyId: "30" },
        { text: "31公斤", keyId: "31" },
        { text: "32公斤", keyId: "32" },
        { text: "33公斤", keyId: "33" },
        { text: "34公斤", keyId: "34" },
        { text: "35公斤", keyId: "35" },
        { text: "36公斤", keyId: "36" },
        { text: "37公斤", keyId: "37" },
        { text: "38公斤", keyId: "38" },
        { text: "39公斤", keyId: "39" },
        { text: "40公斤", keyId: "40" },
        { text: "41公斤", keyId: "41" },
        { text: "42公斤", keyId: "42" },
        { text: "43公斤", keyId: "43" },
        { text: "44公斤", keyId: "44" },
        { text: "45公斤", keyId: "45" },
        { text: "46公斤", keyId: "46" },
        { text: "47公斤", keyId: "47" },
        { text: "48公斤", keyId: "48" },
        { text: "49公斤", keyId: "49" },
        { text: "50公斤", keyId: "50" },
        { text: "51公斤", keyId: "51" },
        { text: "52公斤", keyId: "52" },
        { text: "53公斤", keyId: "53" },
        { text: "54公斤", keyId: "54" },
        { text: "55公斤", keyId: "55" },
        { text: "56公斤", keyId: "56" },
        { text: "57公斤", keyId: "57" },
        { text: "58公斤", keyId: "58" },
        { text: "59公斤", keyId: "59" },
        { text: "60公斤", keyId: "60" },
        { text: "61公斤", keyId: "61" },
        { text: "62公斤", keyId: "62" },
        { text: "63公斤", keyId: "63" },
        { text: "64公斤", keyId: "64" },
        { text: "65公斤", keyId: "65" },
        { text: "66公斤", keyId: "66" },
        { text: "67公斤", keyId: "67" },
        { text: "68公斤", keyId: "68" },
        { text: "69公斤", keyId: "69" },
        { text: "70公斤", keyId: "70" },
        { text: "71公斤", keyId: "71" },
        { text: "72公斤", keyId: "72" },
        { text: "73公斤", keyId: "73" },
        { text: "74公斤", keyId: "74" },
        { text: "75公斤", keyId: "75" },
        { text: "76公斤", keyId: "76" },
        { text: "77公斤", keyId: "77" },
        { text: "78公斤", keyId: "78" },
        { text: "79公斤", keyId: "79" },
        { text: "80公斤", keyId: "80" },
        { text: "81公斤", keyId: "81" },
        { text: "82公斤", keyId: "82" },
        { text: "83公斤", keyId: "83" },
        { text: "84公斤", keyId: "84" },
        { text: "85公斤", keyId: "85" },
        { text: "86公斤", keyId: "86" },
        { text: "87公斤", keyId: "87" },
        { text: "88公斤", keyId: "88" },
        { text: "89公斤", keyId: "89" },
        { text: "90公斤", keyId: "90" },
        { text: "91公斤", keyId: "91" },
        { text: "92公斤", keyId: "92" },
        { text: "93公斤", keyId: "93" },
        { text: "94公斤", keyId: "94" },
        { text: "95公斤", keyId: "95" },
        { text: "96公斤", keyId: "96" },
        { text: "97公斤", keyId: "97" },
        { text: "98公斤", keyId: "98" },
        { text: "99公斤", keyId: "99" },
        { text: "100公斤", keyId: "100" },
        { text: "101公斤", keyId: "101" },
        { text: "102公斤", keyId: "102" },
        { text: "103公斤", keyId: "103" },
        { text: "104公斤", keyId: "104" },
        { text: "105公斤", keyId: "105" },
        { text: "106公斤", keyId: "106" },
        { text: "107公斤", keyId: "107" },
        { text: "108公斤", keyId: "108" },
        { text: "109公斤", keyId: "109" },
        { text: "110公斤", keyId: "110" },
        { text: "111公斤", keyId: "111" },
        { text: "112公斤", keyId: "112" },
        { text: "113公斤", keyId: "113" },
        { text: "114公斤", keyId: "114" },
        { text: "115公斤", keyId: "115" },
        { text: "116公斤", keyId: "116" },
        { text: "117公斤", keyId: "117" },
        { text: "118公斤", keyId: "118" },
        { text: "119公斤", keyId: "119" },
        { text: "120公斤", keyId: "120" },
        { text: "121公斤", keyId: "121" },
        { text: "112公斤", keyId: "122" },
        { text: "123公斤", keyId: "123" },
        { text: "124公斤", keyId: "124" },
        { text: "125公斤", keyId: "125" },
        { text: "126公斤", keyId: "126" },
        { text: "127公斤", keyId: "127" },
        { text: "128公斤", keyId: "128" },
        { text: "129公斤", keyId: "129" },
        { text: "130公斤", keyId: "130" },
        { text: "131公斤", keyId: "131" },
        { text: "132公斤", keyId: "132" },
        { text: "133公斤", keyId: "133" },
        { text: "134公斤", keyId: "134" },
        { text: "135公斤", keyId: "135" },
        { text: "136公斤", keyId: "136" },
        { text: "137公斤", keyId: "137" },
        { text: "138公斤", keyId: "138" },
        { text: "139公斤", keyId: "139" },
        { text: "140公斤", keyId: "140" },
        { text: "141公斤", keyId: "141" },
        { text: "142公斤", keyId: "142" },
        { text: "143公斤", keyId: "143" },
        { text: "144公斤", keyId: "144" },
        { text: "145公斤", keyId: "145" },
        { text: "146公斤", keyId: "146" },
        { text: "147公斤", keyId: "147" },
        { text: "148公斤", keyId: "148" },
        { text: "149公斤", keyId: "149" },
        { text: "150公斤", keyId: "150" },
      ],
      sleepQualityColumns:[
        { keyId: '1', text: '9小时以上' },
        { keyId: '2', text: '7-9小时' },
        { keyId: '3', text: '5-7小时' },
        { keyId: '4', text: '小于5小时' }
      ],
      waistlineColumns: [
        { text: "60厘米", keyId: "60" },
        { text: "61厘米", keyId: "61" },
        { text: "62厘米", keyId: "62" },
        { text: "63厘米", keyId: "63" },
        { text: "64厘米", keyId: "64" },
        { text: "65厘米", keyId: "65" },
        { text: "66厘米", keyId: "66" },
        { text: "67厘米", keyId: "67" },
        { text: "68厘米", keyId: "68" },
        { text: "69厘米", keyId: "69" },
        { text: "70厘米", keyId: "70" },
        { text: "71厘米", keyId: "71" },
        { text: "72厘米", keyId: "72" },
        { text: "73厘米", keyId: "73" },
        { text: "74厘米", keyId: "74" },
        { text: "75厘米", keyId: "75" },
        { text: "76厘米", keyId: "76" },
        { text: "77厘米", keyId: "77" },
        { text: "78厘米", keyId: "78" },
        { text: "79厘米", keyId: "79" },
        { text: "80厘米", keyId: "80" },
        { text: "81厘米", keyId: "81" },
        { text: "82厘米", keyId: "82" },
        { text: "83厘米", keyId: "83" },
        { text: "84厘米", keyId: "84" },
        { text: "85厘米", keyId: "85" },
        { text: "86厘米", keyId: "86" },
        { text: "87厘米", keyId: "87" },
        { text: "88厘米", keyId: "88" },
        { text: "89厘米", keyId: "89" },
        { text: "90厘米", keyId: "90" },
        { text: "91厘米", keyId: "91" },
        { text: "92厘米", keyId: "92" },
        { text: "93厘米", keyId: "93" },
        { text: "94厘米", keyId: "94" },
        { text: "95厘米", keyId: "95" },
        { text: "96厘米", keyId: "96" },
        { text: "97厘米", keyId: "97" },
        { text: "98厘米", keyId: "98" },
        { text: "99厘米", keyId: "99" },
        { text: "100厘米", keyId: "100" },
        { text: "101厘米", keyId: "101" },
        { text: "102厘米", keyId: "102" },
        { text: "103厘米", keyId: "103" },
        { text: "104厘米", keyId: "104" },
        { text: "105厘米", keyId: "105" },
        { text: "106厘米", keyId: "106" },
        { text: "107厘米", keyId: "107" },
        { text: "108厘米", keyId: "108" },
        { text: "109厘米", keyId: "109" },
        { text: "110厘米", keyId: "110" },
        { text: "111厘米", keyId: "111" },
        { text: "112厘米", keyId: "112" },
        { text: "113厘米", keyId: "113" },
        { text: "114厘米", keyId: "114" },
        { text: "115厘米", keyId: "115" },
        { text: "116厘米", keyId: "116" },
        { text: "117厘米", keyId: "117" },
        { text: "118厘米", keyId: "118" },
        { text: "119厘米", keyId: "119" },
        { text: "120厘米", keyId: "120" },
      ],
      smokingStatusColumns: [
        { text: "不吸烟", keyId: "1" },
        { text: "戒烟", keyId: "2" },
        { text: "轻度吸烟者（每日少于10支）", keyId: "3" },
        { text: "中度吸烟者（每日10至19支）", keyId: "4" },
        { text: "重度吸烟者（每日20支及以上）", keyId: "5" },
      ],
      ethnicityColumns: [
        { text: "汉族", keyId: "汉族" },
        { text: "蒙古族", keyId: "蒙古族" },
        { text: "回族", keyId: "回族" },
        { text: "藏族", keyId: "藏族" },
        { text: "维吾尔族", keyId: "维吾尔族" },
        { text: "苗族", keyId: "苗族" },
        { text: "彝族", keyId: "彝族" },
        { text: "壮族", keyId: "壮族" },
        { text: "布依族", keyId: "布依族" },
        { text: "朝鲜族", keyId: "朝鲜族" },
        { text: "满族", keyId: "满族" },
        { text: "侗族", keyId: "侗族" },
        { text: "瑶族", keyId: "瑶族" },
        { text: "白族", keyId: "白族" },
        { text: "土家族", keyId: "土家族" },
        { text: "哈尼族", keyId: "哈尼族" },
        { text: "哈萨克族", keyId: "哈萨克族" },
        { text: "傣族", keyId: "傣族" },
        { text: "黎族", keyId: "黎族" },
        { text: "傈僳族", keyId: "傈僳族" },
        { text: "佤族", keyId: "佤族" },
        { text: "畲族", keyId: "畲族" },
        { text: "高山族", keyId: "高山族" },
        { text: "拉祜族", keyId: "拉祜族" },
        { text: "水族", keyId: "水族" },
        { text: "东乡族", keyId: "东乡族" },
        { text: "纳西族", keyId: "纳西族" },
        { text: "景颇族", keyId: "景颇族" },
        { text: "柯尔克孜族", keyId: "柯尔克孜族" },
        { text: "土族", keyId: "土族" },
        { text: "达斡尔族", keyId: "达斡尔族" },
        { text: "仫佬族", keyId: "仫佬族" },
        { text: "羌族", keyId: "羌族" },
        { text: "布朗族", keyId: "布朗族" },
        { text: "撒拉族", keyId: "撒拉族" },
        { text: "毛南族", keyId: "毛南族" },
        { text: "仡佬族", keyId: "仡佬族" },
        { text: "锡伯族", keyId: "锡伯族" },
        { text: "阿昌族", keyId: "阿昌族" },
        { text: "普米族", keyId: "普米族" },
        { text: "塔吉克族", keyId: "塔吉克族" },
        { text: "怒族", keyId: "怒族" },
        { text: "乌孜别克族", keyId: "乌孜别克族" },
        { text: "俄罗斯族", keyId: "俄罗斯族" },
        { text: "鄂温克族", keyId: "鄂温克族" },
        { text: "德昂族", keyId: "德昂族" },
        { text: "保安族", keyId: "保安族" },
        { text: "裕固族", keyId: "裕固族" },
        { text: "京族", keyId: "京族" },
        { text: "塔塔尔族", keyId: "塔塔尔族" },
        { text: "独龙族", keyId: "独龙族" },
        { text: "鄂伦春族", keyId: "鄂伦春族" },
        { text: "赫哲族", keyId: "赫哲族" },
        { text: "门巴族", keyId: "门巴族" },
        { text: "珞巴族", keyId: "珞巴族" },
        { text: "基诺族", keyId: "基诺族" },
      ],
      residenceColumns:[
         {
           text: "北京市",
           value: "beijing",
           children: [
             { text: "北京市", value: "beijing_city", keyId: "北京市" }
           ]
         },
         {
           text: "上海市", 
           value: "shanghai",
           children: [
             { text: "上海市", value: "shanghai_city", keyId: "上海市" }
           ]
         },
         {
           text: "天津市",
           value: "tianjin",
           children: [
             { text: "天津市", value: "tianjin_city", keyId: "天津市" }
           ]
         },
         {
           text: "重庆市",
           value: "chongqing",
           children: [
             { text: "重庆市", value: "chongqing_city", keyId: "重庆市" }
           ]
         },
         {
           text: "河北省",
           value: "hebei",
           children: [
             { text: "石家庄市", value: "shijiazhuang", keyId: "河北省石家庄市" },
             { text: "唐山市", value: "tangshan", keyId: "河北省唐山市" },
             { text: "秦皇岛市", value: "qinhuangdao", keyId: "河北省秦皇岛市" },
             { text: "邯郸市", value: "handan", keyId: "河北省邯郸市" },
             { text: "邢台市", value: "xingtai", keyId: "河北省邢台市" },
             { text: "保定市", value: "baoding", keyId: "河北省保定市" },
             { text: "张家口市", value: "zhangjiakou", keyId: "河北省张家口市" },
             { text: "承德市", value: "chengde", keyId: "河北省承德市" },
             { text: "沧州市", value: "cangzhou", keyId: "河北省沧州市" },
             { text: "廊坊市", value: "langfang", keyId: "河北省廊坊市" },
             { text: "衡水市", value: "hengshui", keyId: "河北省衡水市" }
           ]
         },
         {
           text: "山西省",
           value: "山西省",
           children: [
             { text: "太原市", value: "太原市", keyId: "山西省太原市" },
             { text: "大同市", value: "大同市", keyId: "山西省大同市" },
             { text: "阳泉市", value: "阳泉市", keyId: "山西省阳泉市" },
             { text: "长治市", value: "长治市", keyId: "山西省长治市" },
             { text: "晋城市", value: "晋城市", keyId: "山西省晋城市" },
             { text: "朔州市", value: "朔州市", keyId: "山西省朔州市" },
             { text: "晋中市", value: "晋中市", keyId: "山西省晋中市" },
             { text: "运城市", value: "运城市", keyId: "山西省运城市" },
             { text: "忻州市", value: "忻州市", keyId: "山西省忻州市" },
             { text: "临汾市", value: "临汾市", keyId: "山西省临汾市" },
             { text: "吕梁市", value: "吕梁市", keyId: "山西省吕梁市" }
           ]
         },
         {
           text: "内蒙古自治区",
           value: "neimenggu",
           children: [
             { text: "呼和浩特市", value: "hohhot", keyId: "内蒙古自治区呼和浩特市" },
             { text: "包头市", value: "baotou", keyId: "内蒙古自治区包头市" },
             { text: "乌海市", value: "wuhai", keyId: "内蒙古自治区乌海市" },
             { text: "赤峰市", value: "chifeng", keyId: "内蒙古自治区赤峰市" },
             { text: "通辽市", value: "tongliao", keyId: "内蒙古自治区通辽市" },
            { text: "鄂尔多斯市", value: "eerduosi", keyId: "内蒙古自治区鄂尔多斯市" },
            { text: "呼伦贝尔市", value: "hulunbeier", keyId: "内蒙古自治区呼伦贝尔市" },
            { text: "巴彦淖尔市", value: "bayannaoer", keyId: "内蒙古自治区巴彦淖尔市" },
            { text: "乌兰察布市", value: "wulanchabu", keyId: "内蒙古自治区乌兰察布市" }
           ]
         },
        {
          text: "辽宁省",
          value: "liaoning",
          children: [
            { text: "沈阳市", value: "shenyang", keyId: "辽宁省沈阳市" },
            { text: "大连市", value: "dalian", keyId: "辽宁省大连市" },
            { text: "鞍山市", value: "anshan", keyId: "辽宁省鞍山市" },
            { text: "抚顺市", value: "fushun", keyId: "辽宁省抚顺市" },
            { text: "本溪市", value: "benxi", keyId: "辽宁省本溪市" },
            { text: "丹东市", value: "dandong", keyId: "辽宁省丹东市" },
            { text: "锦州市", value: "jinzhou", keyId: "辽宁省锦州市" },
            { text: "营口市", value: "yingkou", keyId: "辽宁省营口市" },
            { text: "阜新市", value: "fuxin", keyId: "辽宁省阜新市" },
            { text: "辽阳市", value: "liaoyang", keyId: "辽宁省辽阳市" },
            { text: "盘锦市", value: "panjin", keyId: "辽宁省盘锦市" },
            { text: "铁岭市", value: "tieling", keyId: "辽宁省铁岭市" },
            { text: "朝阳市", value: "chaoyang", keyId: "辽宁省朝阳市" },
            { text: "葫芦岛市", value: "huludao", keyId: "辽宁省葫芦岛市" }
          ]
        },
        {
          text: "吉林省",
          value: "jilin",
          children: [
            { text: "长春市", value: "changchun", keyId: "吉林省长春市" },
            { text: "吉林市", value: "jilin_city", keyId: "吉林省吉林市" },
            { text: "四平市", value: "siping", keyId: "吉林省四平市" },
            { text: "辽源市", value: "liaoyuan", keyId: "吉林省辽源市" },
            { text: "通化市", value: "tonghua", keyId: "吉林省通化市" },
            { text: "白山市", value: "baishan", keyId: "吉林省白山市" },
            { text: "松原市", value: "songyuan", keyId: "吉林省松原市" },
            { text: "白城市", value: "baicheng", keyId: "吉林省白城市" }
          ]
        },
        {
          text: "黑龙江省",
          value: "heilongjiang",
          children: [
            { text: "哈尔滨市", value: "harbin", keyId: "黑龙江省哈尔滨市" },
            { text: "齐齐哈尔市", value: "qiqihar", keyId: "黑龙江省齐齐哈尔市" },
            { text: "鸡西市", value: "jixi", keyId: "黑龙江省鸡西市" },
            { text: "鹤岗市", value: "hegang", keyId: "黑龙江省鹤岗市" },
            { text: "双鸭山市", value: "shuangyashan", keyId: "黑龙江省双鸭山市" },
            { text: "大庆市", value: "daqing", keyId: "黑龙江省大庆市" },
            { text: "伊春市", value: "yichun", keyId: "黑龙江省伊春市" },
            { text: "佳木斯市", value: "jiamusi", keyId: "黑龙江省佳木斯市" },
            { text: "七台河市", value: "qitaihe", keyId: "黑龙江省七台河市" },
            { text: "牡丹江市", value: "mudanjiang", keyId: "黑龙江省牡丹江市" },
            { text: "黑河市", value: "heihe", keyId: "黑龙江省黑河市" },
            { text: "绥化市", value: "suihua", keyId: "黑龙江省绥化市" }
          ]
        },
        {
          text: "江苏省",
          value: "jiangsu",
          children: [
            { text: "南京市", value: "nanjing", keyId: "江苏省南京市" },
            { text: "无锡市", value: "wuxi", keyId: "江苏省无锡市" },
            { text: "徐州市", value: "xuzhou", keyId: "江苏省徐州市" },
            { text: "常州市", value: "changzhou", keyId: "江苏省常州市" },
            { text: "苏州市", value: "suzhou", keyId: "江苏省苏州市" },
            { text: "南通市", value: "nantong", keyId: "江苏省南通市" },
            { text: "连云港市", value: "lianyungang", keyId: "江苏省连云港市" },
            { text: "淮安市", value: "huaian", keyId: "江苏省淮安市" },
            { text: "盐城市", value: "yancheng", keyId: "江苏省盐城市" },
            { text: "扬州市", value: "yangzhou", keyId: "江苏省扬州市" },
            { text: "镇江市", value: "zhenjiang", keyId: "江苏省镇江市" },
            { text: "泰州市", value: "taizhou", keyId: "江苏省泰州市" },
            { text: "宿迁市", value: "suqian", keyId: "江苏省宿迁市" }
          ]
        },
        {
          text: "浙江省",
          value: "zhejiang",
          children: [
            { text: "杭州市", value: "hangzhou", keyId: "浙江省杭州市" },
            { text: "宁波市", value: "ningbo", keyId: "浙江省宁波市" },
            { text: "温州市", value: "wenzhou", keyId: "浙江省温州市" },
            { text: "嘉兴市", value: "jiaxing", keyId: "浙江省嘉兴市" },
            { text: "湖州市", value: "huzhou", keyId: "浙江省湖州市" },
            { text: "绍兴市", value: "shaoxing", keyId: "浙江省绍兴市" },
            { text: "金华市", value: "jinhua", keyId: "浙江省金华市" },
            { text: "衢州市", value: "quzhou", keyId: "浙江省衢州市" },
            { text: "舟山市", value: "zhoushan", keyId: "浙江省舟山市" },
            { text: "台州市", value: "taizhou_zj", keyId: "浙江省台州市" },
            { text: "丽水市", value: "lishui", keyId: "浙江省丽水市" }
          ]
        },
        {
          text: "安徽省",
          value: "anhui",
          children: [
            { text: "合肥市", value: "hefei", keyId: "安徽省合肥市" },
            { text: "芜湖市", value: "wuhu", keyId: "安徽省芜湖市" },
            { text: "蚌埠市", value: "bengbu", keyId: "安徽省蚌埠市" },
            { text: "淮南市", value: "huainan", keyId: "安徽省淮南市" },
            { text: "马鞍山市", value: "maanshan", keyId: "安徽省马鞍山市" },
            { text: "淮北市", value: "huaibei", keyId: "安徽省淮北市" },
            { text: "铜陵市", value: "tongling", keyId: "安徽省铜陵市" },
            { text: "安庆市", value: "anqing", keyId: "安徽省安庆市" },
            { text: "黄山市", value: "huangshan", keyId: "安徽省黄山市" },
            { text: "滁州市", value: "chuzhou", keyId: "安徽省滁州市" },
            { text: "阜阳市", value: "fuyang", keyId: "安徽省阜阳市" },
            { text: "宿州市", value: "suzhou_ah", keyId: "安徽省宿州市" },
            { text: "六安市", value: "liuan", keyId: "安徽省六安市" },
            { text: "亳州市", value: "bozhou", keyId: "安徽省亳州市" },
            { text: "池州市", value: "chizhou", keyId: "安徽省池州市" },
            { text: "宣城市", value: "xuancheng", keyId: "安徽省宣城市" }
          ]
        },
         {
           text: "福建省",
           children: [
             { text: "福州市", keyId: "福建省福州市" },
             { text: "厦门市", keyId: "福建省厦门市" },
             { text: "莆田市", keyId: "福建省莆田市" },
             { text: "三明市", keyId: "福建省三明市" },
             { text: "泉州市", keyId: "福建省泉州市" },
             { text: "漳州市", keyId: "福建省漳州市" },
             { text: "南平市", keyId: "福建省南平市" },
             { text: "龙岩市", keyId: "福建省龙岩市" },
             { text: "宁德市", keyId: "福建省宁德市" }
           ]
         },
         {
           text: "江西省",
           children: [
             { text: "南昌市", keyId: "江西省南昌市" },
             { text: "景德镇市", keyId: "江西省景德镇市" },
             { text: "萍乡市", keyId: "江西省萍乡市" },
             { text: "九江市", keyId: "江西省九江市" },
             { text: "新余市", keyId: "江西省新余市" },
             { text: "鹰潭市", keyId: "江西省鹰潭市" },
             { text: "赣州市", keyId: "江西省赣州市" },
             { text: "吉安市", keyId: "江西省吉安市" },
             { text: "宜春市", keyId: "江西省宜春市" },
             { text: "抚州市", keyId: "江西省抚州市" },
             { text: "上饶市", keyId: "江西省上饶市" }
           ]
         },
         {
           text: "山东省",
           children: [
             { text: "济南市", keyId: "山东省济南市" },
             { text: "青岛市", keyId: "山东省青岛市" },
             { text: "淄博市", keyId: "山东省淄博市" },
             { text: "枣庄市", keyId: "山东省枣庄市" },
             { text: "东营市", keyId: "山东省东营市" },
             { text: "烟台市", keyId: "山东省烟台市" },
             { text: "潍坊市", keyId: "山东省潍坊市" },
             { text: "济宁市", keyId: "山东省济宁市" },
             { text: "泰安市", keyId: "山东省泰安市" },
             { text: "威海市", keyId: "山东省威海市" },
             { text: "日照市", keyId: "山东省日照市" },
             { text: "临沂市", keyId: "山东省临沂市" },
             { text: "德州市", keyId: "山东省德州市" },
             { text: "聊城市", keyId: "山东省聊城市" },
             { text: "滨州市", keyId: "山东省滨州市" },
             { text: "菏泽市", keyId: "山东省菏泽市" }
           ]
         },
         {
           text: "河南省",
           children: [
             { text: "郑州市", keyId: "河南省郑州市" },
             { text: "开封市", keyId: "河南省开封市" },
             { text: "洛阳市", keyId: "河南省洛阳市" },
             { text: "平顶山市", keyId: "河南省平顶山市" },
             { text: "安阳市", keyId: "河南省安阳市" },
             { text: "鹤壁市", keyId: "河南省鹤壁市" },
             { text: "新乡市", keyId: "河南省新乡市" },
             { text: "焦作市", keyId: "河南省焦作市" },
             { text: "濮阳市", keyId: "河南省濮阳市" },
             { text: "许昌市", keyId: "河南省许昌市" },
             { text: "漯河市", keyId: "河南省漯河市" },
             { text: "三门峡市", keyId: "河南省三门峡市" },
             { text: "南阳市", keyId: "河南省南阳市" },
             { text: "商丘市", keyId: "河南省商丘市" },
             { text: "信阳市", keyId: "河南省信阳市" },
             { text: "周口市", keyId: "河南省周口市" },
             { text: "驻马店市", keyId: "河南省驻马店市" },
             { text: "济源市", keyId: "河南省济源市" }
           ]
         },
         {
           text: "湖北省",
           children: [
             { text: "武汉市", keyId: "湖北省武汉市" },
             { text: "黄石市", keyId: "湖北省黄石市" },
             { text: "十堰市", keyId: "湖北省十堰市" },
             { text: "宜昌市", keyId: "湖北省宜昌市" },
             { text: "襄阳市", keyId: "湖北省襄阳市" },
             { text: "鄂州市", keyId: "湖北省鄂州市" },
             { text: "荆门市", keyId: "湖北省荆门市" },
             { text: "孝感市", keyId: "湖北省孝感市" },
             { text: "荆州市", keyId: "湖北省荆州市" },
             { text: "黄冈市", keyId: "湖北省黄冈市" },
             { text: "咸宁市", keyId: "湖北省咸宁市" },
             { text: "随州市", keyId: "湖北省随州市" }
           ]
         },
         {
           text: "湖南省",
           children: [
             { text: "长沙市", keyId: "湖南省长沙市" },
             { text: "株洲市", keyId: "湖南省株洲市" },
             { text: "湘潭市", keyId: "湖南省湘潭市" },
             { text: "衡阳市", keyId: "湖南省衡阳市" },
             { text: "邵阳市", keyId: "湖南省邵阳市" },
             { text: "岳阳市", keyId: "湖南省岳阳市" },
             { text: "常德市", keyId: "湖南省常德市" },
             { text: "张家界市", keyId: "湖南省张家界市" },
             { text: "益阳市", keyId: "湖南省益阳市" },
             { text: "郴州市", keyId: "湖南省郴州市" },
             { text: "永州市", keyId: "湖南省永州市" },
             { text: "怀化市", keyId: "湖南省怀化市" },
             { text: "娄底市", keyId: "湖南省娄底市" }
           ]
         },
         {
           text: "广东省",
           children: [
             { text: "广州市", keyId: "广东省广州市" },
             { text: "深圳市", keyId: "广东省深圳市" },
             { text: "珠海市", keyId: "广东省珠海市" },
             { text: "汕头市", keyId: "广东省汕头市" },
             { text: "佛山市", keyId: "广东省佛山市" },
             { text: "韶关市", keyId: "广东省韶关市" },
             { text: "湛江市", keyId: "广东省湛江市" },
             { text: "肇庆市", keyId: "广东省肇庆市" },
             { text: "江门市", keyId: "广东省江门市" },
             { text: "茂名市", keyId: "广东省茂名市" },
             { text: "惠州市", keyId: "广东省惠州市" },
             { text: "梅州市", keyId: "广东省梅州市" },
             { text: "汕尾市", keyId: "广东省汕尾市" },
             { text: "河源市", keyId: "广东省河源市" },
             { text: "阳江市", keyId: "广东省阳江市" },
             { text: "清远市", keyId: "广东省清远市" },
             { text: "东莞市", keyId: "广东省东莞市" },
             { text: "中山市", keyId: "广东省中山市" },
             { text: "潮州市", keyId: "广东省潮州市" },
             { text: "揭阳市", keyId: "广东省揭阳市" },
             { text: "云浮市", keyId: "广东省云浮市" }
           ]
         },
         {
           text: "广西壮族自治区",
           children: [
             { text: "南宁市", keyId: "广西壮族自治区南宁市" },
             { text: "柳州市", keyId: "广西壮族自治区柳州市" },
             { text: "桂林市", keyId: "广西壮族自治区桂林市" },
             { text: "梧州市", keyId: "广西壮族自治区梧州市" },
             { text: "北海市", keyId: "广西壮族自治区北海市" },
             { text: "防城港市", keyId: "广西壮族自治区防城港市" },
             { text: "钦州市", keyId: "广西壮族自治区钦州市" },
             { text: "贵港市", keyId: "广西壮族自治区贵港市" },
             { text: "玉林市", keyId: "广西壮族自治区玉林市" },
             { text: "百色市", keyId: "广西壮族自治区百色市" },
             { text: "贺州市", keyId: "广西壮族自治区贺州市" },
             { text: "河池市", keyId: "广西壮族自治区河池市" },
             { text: "来宾市", keyId: "广西壮族自治区来宾市" },
             { text: "崇左市", keyId: "广西壮族自治区崇左市" }
           ]
         },
         {
           text: "海南省",
           children: [
             { text: "海口市", keyId: "海南省海口市" },
             { text: "三亚市", keyId: "海南省三亚市" },
             { text: "三沙市", keyId: "海南省三沙市" },
             { text: "儋州市", keyId: "海南省儋州市" }
           ]
         },
         {
           text: "四川省",
           children: [
             { text: "成都市", keyId: "四川省成都市" },
             { text: "自贡市", keyId: "四川省自贡市" },
             { text: "攀枝花市", keyId: "四川省攀枝花市" },
             { text: "泸州市", keyId: "四川省泸州市" },
             { text: "德阳市", keyId: "四川省德阳市" },
             { text: "绵阳市", keyId: "四川省绵阳市" },
             { text: "广元市", keyId: "四川省广元市" },
             { text: "遂宁市", keyId: "四川省遂宁市" },
             { text: "内江市", keyId: "四川省内江市" },
             { text: "乐山市", keyId: "四川省乐山市" },
             { text: "南充市", keyId: "四川省南充市" },
             { text: "眉山市", keyId: "四川省眉山市" },
             { text: "宜宾市", keyId: "四川省宜宾市" },
             { text: "广安市", keyId: "四川省广安市" },
             { text: "达州市", keyId: "四川省达州市" },
             { text: "雅安市", keyId: "四川省雅安市" },
             { text: "巴中市", keyId: "四川省巴中市" },
             { text: "资阳市", keyId: "四川省资阳市" }
           ]
         },
         {
           text: "贵州省",
           children: [
             { text: "贵阳市", keyId: "贵州省贵阳市" },
             { text: "六盘水市", keyId: "贵州省六盘水市" },
             { text: "遵义市", keyId: "贵州省遵义市" },
             { text: "安顺市", keyId: "贵州省安顺市" },
             { text: "毕节市", keyId: "贵州省毕节市" },
             { text: "铜仁市", keyId: "贵州省铜仁市" }
           ]
         },
         {
           text: "云南省",
           children: [
             { text: "昆明市", keyId: "云南省昆明市" },
             { text: "曲靖市", keyId: "云南省曲靖市" },
             { text: "玉溪市", keyId: "云南省玉溪市" },
             { text: "保山市", keyId: "云南省保山市" },
             { text: "昭通市", keyId: "云南省昭通市" },
             { text: "丽江市", keyId: "云南省丽江市" },
             { text: "普洱市", keyId: "云南省普洱市" },
             { text: "临沧市", keyId: "云南省临沧市" }
           ]
         },
         {
           text: "西藏自治区",
           children: [
             { text: "拉萨市", keyId: "西藏自治区拉萨市" },
             { text: "日喀则市", keyId: "西藏自治区日喀则市" },
             { text: "昌都市", keyId: "西藏自治区昌都市" },
             { text: "林芝市", keyId: "西藏自治区林芝市" },
             { text: "山南市", keyId: "西藏自治区山南市" },
             { text: "那曲市", keyId: "西藏自治区那曲市" },
             { text: "阿里地区", keyId: "西藏自治区阿里地区" }
           ]
         },
         {
           text: "陕西省",
           children: [
             { text: "西安市", keyId: "陕西省西安市" },
             { text: "铜川市", keyId: "陕西省铜川市" },
             { text: "宝鸡市", keyId: "陕西省宝鸡市" },
             { text: "咸阳市", keyId: "陕西省咸阳市" },
             { text: "渭南市", keyId: "陕西省渭南市" },
             { text: "延安市", keyId: "陕西省延安市" },
             { text: "汉中市", keyId: "陕西省汉中市" },
             { text: "榆林市", keyId: "陕西省榆林市" },
             { text: "安康市", keyId: "陕西省安康市" },
             { text: "商洛市", keyId: "陕西省商洛市" }
           ]
         },
         {
           text: "甘肃省",
           children: [
             { text: "兰州市", keyId: "甘肃省兰州市" },
             { text: "嘉峪关市", keyId: "甘肃省嘉峪关市" },
             { text: "金昌市", keyId: "甘肃省金昌市" },
             { text: "白银市", keyId: "甘肃省白银市" },
             { text: "天水市", keyId: "甘肃省天水市" },
             { text: "武威市", keyId: "甘肃省武威市" },
             { text: "张掖市", keyId: "甘肃省张掖市" },
             { text: "平凉市", keyId: "甘肃省平凉市" },
             { text: "酒泉市", keyId: "甘肃省酒泉市" },
             { text: "庆阳市", keyId: "甘肃省庆阳市" },
             { text: "定西市", keyId: "甘肃省定西市" },
             { text: "陇南市", keyId: "甘肃省陇南市" }
           ]
         },
         {
           text: "青海省",
           children: [
             { text: "西宁市", keyId: "青海省西宁市" },
             { text: "海东市", keyId: "青海省海东市" }
           ]
         },
         {
           text: "宁夏回族自治区",
           children: [
             { text: "银川市", keyId: "宁夏回族自治区银川市" },
             { text: "石嘴山市", keyId: "宁夏回族自治区石嘴山市" },
             { text: "吴忠市", keyId: "宁夏回族自治区吴忠市" },
             { text: "固原市", keyId: "宁夏回族自治区固原市" },
             { text: "中卫市", keyId: "宁夏回族自治区中卫市" }
           ]
         },
         {
           text: "新疆维吾尔自治区",
           children: [
             { text: "乌鲁木齐市", keyId: "新疆维吾尔自治区乌鲁木齐市" },
             { text: "克拉玛依市", keyId: "新疆维吾尔自治区克拉玛依市" },
             { text: "吐鲁番市", keyId: "新疆维吾尔自治区吐鲁番市" },
             { text: "哈密市", keyId: "新疆维吾尔自治区哈密市" }
           ]
         },
         {
           text: "香港特别行政区",
           children: [
             { text: "香港特别行政区", keyId: "香港特别行政区" }
           ]
         },
         {
           text: "澳门特别行政区",
           children: [
             { text: "澳门特别行政区", keyId: "澳门特别行政区" }
           ]
         },
         {
           text: "台湾省",
           children: [
             { text: "台湾省", keyId: "台湾省" }
           ]
         }
       ],
      industryColumns: [
        { text: "重体力行业（司机、医务工作者等）", keyId: "1" },
        { text: "轻体力（职员）", keyId: "2" },
      ],
      dietaryHabitsColumns: [
        { text: "荤素均衡", keyId: "1" },
        { text: "荤食为主", keyId: "2" },
        { text: "素食为主", keyId: "3" },
      ],
      dietPreferenceColumns: [
        { keyId: '1', text: '饮食清淡' },
        { keyId: '2', text: '偏油' },
        { keyId: '3', text: '偏咸' },
        { keyId: '4', text: '偏甜' }
      ],
      drinkingStatusColumns: [
        { text: "从不饮酒", keyId: "1" },
        { text: "偶尔饮酒", keyId: "2" },
        { text: "每日饮酒", keyId: "3" },
        { text: "已戒酒", keyId: "4" },
      ],
      exerciseFreqColumns: [
  { keyId: '1', text: '每周小于三次（20分钟一次）' },
  { keyId: '2', text: '每周3次或以上（20分钟一次）' }
      ],
      showPicker1: false,
      userCode: "",
    };
  },
  components: {
    picke: () => import("./picke"),
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight'])
  },
  mounted() {
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
    this.getData();
  },
  beforeDestroy() {
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    sleepQualityClick() {
      this.sleepQualityPicker = true
    },
    waistlineShow() {
      this.waistlinePicker = true
    },
    smokingStatusClick() {
      this.smokingStatusPicker = true
    },
    ethnicityClick() {
      this.ethnicityPicker = true
    },
    residenceClick() {
      this.residencePicker = true
    },
    industryClick() {
      this.industryPicker = true
    },
    dietaryHabitsClick() {
      this.dietaryHabitsPicker = true
    },
    dietPreferenceClick() {
      this.dietPreferencePicker = true
    },
    drinkingStatusClick() {
      this.drinkingStatusPicker = true
    },
    exerciseFreqClick() {
      this.exerciseFreqPicker = true
    },
    focusEvent(e){
      console.log('focusEvent')     
        let ele = e.target
        let kdv = document.getElementById('btm-keyboard-div')
        if(kdv) {
          kdv.style = 'height: 450px'
        }
        ele.scrollIntoView(true)//滚动跟父元素有关系，注意css设置，且ture需要显示传入
    },
    blurEvent(){
      console.log('blurEvent')
        let kdv = document.getElementById('btm-keyboard-div')
        if(kdv) {
          kdv.style = 'height:none'
        }
    },
    getData() {
      health().then((res) => {
        if (res.code == 1000) {
          // 初始化ID变量
          this.smokingStatusId = '';
          this.industryId = '';
          this.dietPreferenceId = '';
          this.exerciseFreqId = '';
          this.sleepQualityId = '';
          this.dietaryHabitsId = '';
          this.drinkingStatusId = '';
          
          this.uesr = res.data.name || "";
          this.IDNumber = res.data.idNo || "";
          if(res.data.sex== 2) {
            this.gender = '女'
          }else  {
            this.gender = '男'
          }
          if(res.data.birthday == null) {
            this.birthday = ''
          }else {
            this.birthday = this.convertDateString(res.data.birthday) || "";
          }
          if(res.data.height != null) {
            this.height = res.data.height + "厘米" || "";
          }
          if(res.data.weight != null) {
            this.weight = res.data.weight + "公斤" || "";
          }
          if(res.data.waistline != null) {
            this.waistline = res.data.waistline + "厘米" || "";
          }
          if(res.data.smokingStatus) {
            this.smokingStatusId = res.data.smokingStatus;
            if(res.data.smokingStatus == 1) {
              this.smokingStatus = "不吸烟"
            }else if(res.data.smokingStatus == 2) {
              this.smokingStatus = "戒烟"
            }else if(res.data.smokingStatus == 3) {
              this.smokingStatus = "轻度吸烟者（每日少于10支）"
            }else if(res.data.smokingStatus == 4) {
               this.smokingStatus = "中度吸烟者（每日10至19支）"
          }else if(res.data.smokingStatus == 5) {
            this.smokingStatus = "重度吸烟者（每日20支及以上）"
          }
          }
          if(res.data.ethnicity) {
            this.ethnicity = res.data.ethnicity || "";
          }
          if(res.data.residence) {
            this.residence = res.data.residence || "";
          }
          if(res.data.industry) {
            this.industryId = res.data.industry;
            if(res.data.industry == 1) {
              this.industry = "重体力行业（司机、医务工作者等）"
            }else if(res.data.industry == 2) {
              this.industry = "轻体力（职员）"
            }
          }
          if(res.data.dietaryHabits) {
            this.dietaryHabitsId = res.data.dietaryHabits;
            if(res.data.dietaryHabits == 1) {
              this.dietaryHabits = "荤素均衡"
            }else if(res.data.dietaryHabits == 2) {
              this.dietaryHabits = "荤食为主"
            }else if(res.data.dietaryHabits == 3) {
              this.dietaryHabits = "素食为主"
            }
          }
          if(res.data.dietPreference) {
            this.dietPreferenceId = res.data.dietPreference;
            this.dietPreference = this.getTextByKeyId(this.dietPreferenceColumns, res.data.dietPreference);
          }
          if(res.data.drinkingStatus) {
            this.drinkingStatusId = res.data.drinkingStatus;
            if(res.data.drinkingStatus == 1) {
              this.drinkingStatus = "从不饮酒"
            }else if(res.data.drinkingStatus == 2) {
              this.drinkingStatus = "偶尔饮酒"
            }else if(res.data.drinkingStatus == 3) {
              this.drinkingStatus = "每日饮酒"
            }else if(res.data.drinkingStatus == 4) {
              this.drinkingStatus = "已戒酒"
            }
          }
          if(res.data.exerciseFreq) {
            this.exerciseFreqId = res.data.exerciseFreq;
            this.exerciseFreq = this.getTextByKeyId(this.exerciseFreqColumns, res.data.exerciseFreq);
          }
       
          
          if(res.data.sleepQuality) {
            this.sleepQualityId = res.data.sleepQuality;
            if(res.data.sleepQuality == 1) {
              this.sleepQuality = "9小时以上"
            }else if(res.data.sleepQuality == 2) {
              this.sleepQuality = "7-9小时"
            }else if(res.data.sleepQuality == 3) {
              this.sleepQuality = "5-7小时"
            }else if(res.data.sleepQuality == 4) {
              this.sleepQuality = "小于5小时"
            }
          }
          
          if(res.data.userDetailAddress) {
            this.userDetailAddress = res.data.userDetailAddress
          }
          
          if(res.data.communityPhone) {
            this.communityPhone = res.data.communityPhone
          }
          
        }
      });
      this.userCode = localStorage.getItem('userCode'); 
    },
    edit() {
     
      if(this.uesr == '' || this.uesr == null) {
        this.$message.error('用户名为必填项，请输入用户名');
        return
      }
      if(this.gender == '' || this.gender == null) {
        this.$message.error('性别为必填项，请选择性别');
        return
      }
      if(this.birthday == '' || this.birthday == null) {
        this.$message.error('出生日期为必填项，请选择出生日期');
        return
      }
      if(this.height == '' || this.height == null) {
        this.$message.error('身高为必填项，请选择身高');
        return
      }
      if(this.weight == '' || this.weight == null) {
        this.$message.error('体重为必填项，请选择体重');
        return
      }
      if(this.waistline == '' || this.waistline == null) {
        this.$message.error('腰围为必填项，请选择腰围');
        return
      }
      if(this.smokingStatus == '' || this.smokingStatus == null) {
        this.$message.error('是否吸烟为必填项，请选择是否吸烟');
        return
      }
      if(this.ethnicity == '' || this.ethnicity == null) {
        this.$message.error('民族为必填项，请选择民族');
        return
      }
      if(this.residence == '' || this.residence == null) {
        this.$message.error('常住地为必填项，请选择常住地');
        return
      }
      if(this.industry == '' || this.industry == null) {
        this.$message.error('所在行业为必填项，请选择所在行业');
        return
      }
      if(this.sleepQuality == '' || this.sleepQuality == null) {
        this.$message.error('睡眠质量为必填项，请选择睡眠质量');
        return
      }
      if(this.IDNumber == '' || this.IDNumber == null) {
        this.$message.error('证件号为必填项，请输入证件号');
        return
      }
      if(this.gender== '男') {
        this.gender = 1
      }else  {
        this.gender = 2
      }
      
      // 设置medHis
      // let medHis = false;
      console.log(this.formatDate(new Date(this.transferTime(this.birthday))),'454')
      // return
     
      var obj = {
        userCode: this.userCode,
        name: this.uesr,
        idNo: this.IDNumber,
        sex: this.gender,
        birthday: this.formatDate(new Date(this.transferTime(this.birthday))),
        height: parseInt(this.height.slice(0, -2)),
        weight: parseInt(this.weight.slice(0, -2)),
        waistline: parseInt(this.waistline.slice(0, -2)),
        ethnicity: this.ethnicity,
        residence: this.residence,
        industry: this.industryId,
        // medHis: medHis,
        takeMed: false,
        sleepQuality: this.sleepQualityId,
        smokingStatus: this.smokingStatusId,
        drinkingStatus: this.drinkingStatusId,
        dietaryHabits: this.dietaryHabitsId,
        dietPreference: this.dietPreferenceId,
        exerciseFreq: this.exerciseFreqId,
        userDetailAddress: this.userDetailAddress,
        communityPhone: this.communityPhone,
      };
      uphealthinfo2(obj).then(async (res) => {
        if (res.code == 1000) {
          await this.handleSaveSuccess();
        }
      });
    },
    /**
     * 保存成功后检查疾病用药是否完善，并决定跳转
     * @returns {Promise<void>}
     */
    async handleSaveSuccess() {
      this.$message({
        type: 'success',
        message: '编辑成功!'
      });

      const { complete } = await evaluateDiseaseMedicationStatus();
      if (!complete) {
        try {
          await this.$confirm(
            '请完善您的疾病用药情况，否则将影响您的健康日报、健康周报生成',
            '友情提示',
            {
              confirmButtonText: '去完善',
              cancelButtonText: '取消',
              type: 'warning',
              closeOnClickModal: false,
              closeOnPressEscape: true
            }
          );
          sessionStorage.setItem('healthArchive_openDiseaseTab', '1');
          this.$router.push({
            path: '/healthArchive',
            query: { from: this.$route.query.from || 'information' }
          }).catch(() => {});
        } catch (error) {
          this.navigateAfterSave();
        }
        return;
      }

      this.navigateAfterSave();
    },
    /**
     * 保存成功后按来源页面跳转
     * @returns {void}
     */
    navigateAfterSave() {
      const from = this.$route.query.from;
      if (from === 'healthHomePage') {
        this.$router.push({ path: '/healthHomePage' }).catch(() => {});
        return;
      }
      this.$router.push({ path: '/mine' }).catch(() => {});
    },
    convertDateString(dateString) {
      // 假设日期格式为 "jsYYYY-MM-DD"，去除开头的 "js"
      const dateParts = dateString.split('-');
      const year = dateParts[0];
      const month = dateParts[1]; // 月份是从 1 开始的，所以要减去 1
      const day = dateParts[2];
    
      return `${year}年${month}月${day}日`;
    },
    formatDate(date) {
      console.log(date,'484')
      var year = date.getFullYear();
      console.log(year,'488')
      var month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月份是从0开始的
      console.log(month,'490')
      var day = date.getDate().toString().padStart(2, "0");
      console.log(day,'492')
      return year + "-" + month + "-" + day;
    },
    transferTime(data) {
      let str = data;
      let regex = /年/g; // 使用正则表达式并设置全局标志g
      let regex1 = /月/g; // 使用正则表达式并设置全局标志g
      var newStr = str.replace(regex, "/"); // 替换所有的"World"为"Earth"
      var newStr2 = newStr.replace(regex1, "/"); // 替换所有的"World"为"Earth"
      return newStr2.slice(0, -1);
    },
    cancel() {
      this.showPicker = false;
    },
    onConfirm(idType) {
      this.height = idType.text;
      console.log(idType);
      this.showPicker = false;
    },
    cancel1() {
      this.showPicker1 = false;
    },
    sleepQualitycancel() {
     this.sleepQualityPicker = false;
    },
    sleepQualityonConfirm(idType) {
      this.sleepQuality = idType.text;
      this.sleepQualityId = idType.keyId;
      this. sleepQualityPicker = false;
    },
    waistlineonConfirm(idType) {
      this.waistline = idType.text;
      this.waistlinePicker = false;
    },
    waistlinecancel() {
      this.waistlinePicker = false;
    },
    smokingStatusonConfirm(idType) {
      this.smokingStatus = idType.text;
      this.smokingStatusId = idType.keyId;
      this.smokingStatusPicker = false;
    },
    smokingStatuscancel() {
      this.smokingStatusPicker = false;
    },
    ethnicityonConfirm(idType) {
      this.ethnicity = idType.text;
      this.ethnicityPicker = false;
    },
    ethnicitycancel() {
      this.ethnicityPicker = false;
    },
    residenceonConfirm({ selectedOptions, value }) {
      console.log('级联选择器选择结果:', { selectedOptions, value });
      
      if (selectedOptions && selectedOptions.length >= 2) {
        const cityOption = selectedOptions[selectedOptions.length - 1];
        this.residence = cityOption.keyId;
        // 更新级联选择器的值，使用选中的文本值
        this.residenceCascaderValue = selectedOptions.map(option => option.text);
        console.log('选择的常住地:', cityOption);
        console.log('级联选择器值:', this.residenceCascaderValue);
      }
      
      this.residencePicker = false;
    },
    residencecancel() {
      this.residencePicker = false;
    },
    industryonConfirm(idType) {
      this.industry = idType.text;
      this.industryId = idType.keyId;
      this.industryPicker = false;
    },
    industrycancel() {
      this.industryPicker = false;
    },
    dietaryHabitsonConfirm(idType) {
      this.dietaryHabits = idType.text;
      this.dietaryHabitsId = idType.keyId;
      this.dietaryHabitsPicker = false;
    },
    dietaryHabitscancel() {
      this.dietaryHabitsPicker = false;
    },
    dietPreferenceonConfirm(idType) {
      this.dietPreference = idType.text;
      this.dietPreferenceId = idType.keyId;
      this.dietPreferencePicker = false;
    },
    dietPreferencecancel() {
      this.dietPreferencePicker = false;
    },
    drinkingStatusonConfirm(idType) {
      this.drinkingStatus = idType.text;
      this.drinkingStatusId = idType.keyId;
      this.drinkingStatusPicker = false;
    },
    drinkingStatuscancel() {
      this.drinkingStatusPicker = false;
    },
    exerciseFreqonConfirm(idType) {
      this.exerciseFreq = idType.text;
      this.exerciseFreqId = idType.keyId;
      this.exerciseFreqPicker = false;
    },
    exerciseFreqcancel() {
      this.exerciseFreqPicker = false;
    },
    onConfirm1(idType) {
      this.weight = idType.text;
      console.log(idType);
      this.showPicker1 = false;
    },
    childShow(msg) {
      this.value = msg;
      console.log(msg, "msg");
    },
    parentMethod(msg) {
      console.log(msg,'517');
      this.birthday = msg;
      this.value = false;
    },
    timeClick() {
      this.value = true;
    },
    Sexselection(type) {
      if (type == 1) {
        this.genderInput = "男";
      } else {
        this.genderInput = "女";
      }
    },
    qdClikc() {
      this.value = false;
      if (this.type == 1) {
        this.uesr = this.userInput;
        this.cover = false;
      } else if (this.type == 2) {
        this.cover = false;
        this.gender = this.genderInput;
      } else if (this.type == 3) {
        if (this.isValidID(String(this.IDNumberInput))) {
          this.cover = false;
          this.ts = false;
        } else {
          this.cover = true;
          this.ts = true;
          // 验证失败的逻辑
          console.log("身份证号码无效");
        }
        this.IDNumber = this.IDNumberInput;
      } else if (this.type == 4) {
        this.userDetailAddress = this.homeAddressInput;
        this.cover = false;
      } else if (this.type == 5) {
        this.communityPhone = this.communityPhoneInput;
        this.cover = false;
      }
      // this.edit()
    },
    maskIdCard(idCard) {
      // 获取前6位
      const firstPart = idCard.slice(0, 6);
      // 生成中间8位的星号
      const middlePart = "*".repeat(8);
      // 获取后4位
      const lastPart = idCard.slice(14);

      // 拼接成新的字符串
      return firstPart + middlePart + lastPart;
    },
    isValidID(idNumber) {
      console.log(idNumber);
      // 这里简单实现一个身份证校验规则，实际应根据中国大陆的身份证标准进行校验
      if (
        !/^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          idNumber
        )
      ) {
        return false; // 格式校验
      }
      var sum = 0;
      var weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var checkCodes = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
      // 计算加权和
      for (var i = 0; i < 17; i++) {
        sum += idNumber.substring(i, i + 1) * weights[i];
      }
      // 计算校验码
      var mod = sum % 11;
      var lastChar = idNumber.substring(17, 18);
      if (checkCodes[mod] !== lastChar) {
        return false; // 校验码校验
      }
      return true;
    },
    genderShow() {
      this.type = 2;
      this.genderInput = this.gender;
      this.cover = true;
    },
    IDNumberShow() {
      this.type = 3;
      this.IDNumberInput = this.IDNumber;
      this.cover = true;
    },
    homeAddressShow() {
      this.type = 4;
      this.homeAddressInput = this.userDetailAddress;
      this.cover = true;
    },
    communityPhoneShow() {
      this.type = 5;
      this.communityPhoneInput = this.communityPhone;
      this.cover = true;
    },
    userShow() {
      this.type = 1;
      this.userInput = this.uesr;
      this.cover = true;
    },
    getDialogTitle() {
      switch(this.type) {
        case 1:
          return '修改用户名';
        case 2:
          return '修改性别';
        case 3:
          return '修改证件号';
        case 4:
          return '添加家庭地址';
        case 5:
          return '添加社区电话';
        default:
          return '请输入信息';
      }
    },
    getTextByKeyId(columns, keyId) {
      if (!columns || !keyId) return '';
      const item = columns.find(col => col.keyId === keyId);
      return item ? item.text : keyId;
    },
    getKeyIdByText(columns, text) {
      if (!columns || !text) return text;
      const item = columns.find(col => col.text === text);
      return item ? item.keyId : text;
    },
    /**
     * 获取常住地显示文本
     */
    getResidenceDisplayText() {
      if (!this.residence) return '';
      
      // 如果residenceCascaderValue有值，使用它来显示
      if (this.residenceCascaderValue && this.residenceCascaderValue.length > 0) {
        return this.residenceCascaderValue.join('');
      }
      
      // 否则根据residence查找对应的显示文本
      if (this.residenceColumns && Array.isArray(this.residenceColumns)) {
        for (const province of this.residenceColumns) {
          if (province.children && Array.isArray(province.children)) {
            for (const city of province.children) {
              if (city.keyId === this.residence) {
                return `${province.text}${city.text}`;
              }
            }
          }
        }
      }
      
      return this.residence;
    },
  },
  created() {
   
  }
};
</script>
<style scoped>
.information-page {
  min-height: 100vh;
  background-color: #F7F7F7;
  padding-bottom: 100px;
}

/* 顶部导航栏 */
.information-header {
  position: relative;
  width: 100%;
  min-height: 120px;
  overflow: hidden;
  margin-bottom: 0;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.header-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.header-nav {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  min-height: 44px;
}

.nav-back-wrapper {
  flex-shrink: 0;
}

.nav-back-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #000000;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  i {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
  
  &:hover {
    background: #f5f5f5;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0) scale(0.95);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
}

.nav-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}

.nav-placeholder {
  width: 24px;
}

/* 内容区域 */
.content-wrapper {
  background-color: #F7F7F7;
  padding: 16px;
  margin-top: -20px;
  border-radius: 20px 20px 0 0;
  position: relative;
  z-index: 1;
}

/* 信息分组 */
.info-section {
  margin-top: 0;
  margin-bottom: 16px;
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-section:first-child {
  margin-top: 0;
}

.section-title {
  padding: 16px 16px 12px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  background-color: #ffffff;
}

.info-list {
  background-color: #ffffff;
  border-radius: 0 0 12px 12px;
}

.jiazu {
  width:300px !important;
  height: 100px !important;
}
#cover {
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%; /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  height: 100%;
  filter: alpha(opacity=100); /*设置透明度为100%*/
  opacity: 1; /*非IE浏览器下设置透明度为100%*/
  display: block;
  z-index: 999;
}
.Popupclass {
  position: fixed;
  bottom: 0vw;
  z-index: 9999;
  height: 200px;
  border-radius: 20px 20px 0px 0px;
}
.Popupclass {
  width: 100%;
  z-index: 9999;
  background-color: #ffffff;
  margin: 0 auto;
  margin-top: 15vw;
  box-sizing: border-box;
}
.close {
  text-align: right;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #151515;
  height: 60px;
  background: #f9fafb;
  border-radius: 20px 20px 0px 0px;
  /* line-height: 60px; */
  /* margin-bottom: 100px; */
}
.el-input {
  width: 100% !important;
}
.totalBox {
  width: 100%;
  height: 84px;
  background: #ffffff;
  padding: 10px 21px;
}
.defeat {
  width: 100%;
  height: 64px;
  background: #f3f3f3;
  border-radius: 10px;
  /* margin-top: 16px; */
  display: flex;
  /* justify-content: center;  */
  align-items: left;
}
.drop {
  width: 8px;
  height: 8px;
  background: #209f66;
  border-radius: 100%;
  margin: 0px 10px;
  position: absolute;
  top: 18px;
  left: 2px;
}
.defeatName {
  height: 64px;
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center;  */
  margin-left: 10px;
  padding-left: 28px;
  position: relative;
}
.li {
  width: 100%;
  min-height: 56px;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e4ea;
  padding: 0px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.li:last-child {
  border-bottom: none;
}

.name {
  color: rgba(0, 0, 0, 0.9);
  font-size: 15px;
  flex: 1;
}

.value {
  font-weight: 400;
  font-size: 15px;
  color: #151515;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: right;
}

.value i {
  font-size: 16px;
  color: #999999;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  line-height: 1;
}

/* 所在行业和每周运动时长的特殊样式 */
.industry-item .name,
.exercise-item .name {
  flex: 0 0 auto;
  min-width: 0;
  white-space: nowrap;
  margin-right: 12px;
}

.industry-item .value,
.exercise-item .value {
  width: 60%;
  flex: 0 0 60%;
  min-width: 0;
  justify-content: flex-end;
  flex-wrap: nowrap;
  align-items: center;
  
}

.industry-item .value span,
.exercise-item .value span {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 0 1 auto;
  min-width: 0;
  max-width: calc(100% - 24px);
  vertical-align: middle;
}

.industry-item .value i,
.exercise-item .value i {
  flex-shrink: 0;
  flex-grow: 0;
}

.li div {
  display: inline-block;
}
.qx {
  color: rgb(102, 111, 131);
  font-weight: 500;
  float: left;
  margin-left: 20px;
  font-size: 18px;
}
.qd {
  color: #00c275;
  font-weight: 500;
  float: right;
  margin-right: 20px;
  font-size: 18px;
}
.gender {
  padding: 16px 20px;
  width: 100%;
  margin: 0px auto;
  font-size: 17px;
  border-bottom: 1px solid #e2e4ea;
}
.el-icon-success {
  font-size: 26px !important;
  color: #07c160 !important;
  float: right;
}
.round {
  width: 24px;
  height: 24px;
  border: 1px solid #000000;
  opacity: 0.3;
  border-radius: 100%;
  float: right;
}
.ts {
  color: red;
  font-size: 13px;
}
/* 保存按钮 */
.save-button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background-color: #F7F7F7;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.save-button {
  position: relative;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
}

.save-bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.save-text {
  position: relative;
  z-index: 2;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}

.required {
  color: red;
  margin-right: 2px;
}
</style>




// WEBPACK FOOTER //
// src/views/information/index.vue